import React, { useState } from 'react'
import Password from '../../input_fields/Password';
import PasswordStrengthBar from '../../input_fields/PasswordStrengthBar';
import { changePasswordTodo } from '../../../redux/slice/ChangePassword';
import { ChangePasswordSchema } from './ValidationSchema';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import SaveButton from '../../buttons/SaveButton.jsx';

export default function ChangePasswordForm() {
    const [spinner, setSpinner] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { state } = useLocation();

    const initialValues = {
        email: state?.email,
        otp: state?.otp,
        password: "",
        confirm_password: ''
    };

    const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } = useFormik({
        initialValues: initialValues,
        validationSchema: ChangePasswordSchema,
        enableReinitialize: true,

        onSubmit: (values, action) => {
            setSpinner(true);
            dispatch(changePasswordTodo({ values })).then((res) => signup_res(res.payload));
        }
    });

    const signup_res = (res, action) => {
        console.log("res", res)
        if (res?.status == 200 || res?.status == 201) {
            toast.success(res?.data?.message, { position: "bottom-right" })
            setTimeout(() => {
                navigate('/login');
            }, 1500);
            setSpinner(false)
        }
        else if (res?.status == 404) {
            setSpinner(false)
            toast.error(res?.data?.message, { position: "bottom-right" })
        } else if (res?.status == 500) {
            setSpinner(false)
            toast.error("Server error!!..", { position: "bottom-right" })
        } else {
            setSpinner(false)
            toast.error("Something went wrong!!..", { position: "bottom-right" })
        }
    }
    return (
        <>
            <Form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                <div className="">
                    <div className='container-fluid'>
                        <div className="row">
                            <div className="col-md-12">
                                <h2 className="mb-4 biolink-title-gradient " >Change Password...!!</h2>
                            </div>
                            <div className="col-md-12">
                                <Password
                                    label_name={"Password"}
                                    placeholder=''
                                    disabled={false}
                                    name='password'
                                    value={values.password || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.password && touched.password ? (<span className='text-danger form_label'>{errors.password}</span>) : null}
                                />
                                <PasswordStrengthBar password={values.password} />
                            </div>
                            <div className="col-md-12">
                                <Password
                                    label_name={"Confirm Password"}
                                    placeholder=''
                                    disabled={false}
                                    name='confirm_password'
                                    value={values.confirm_password || ''}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.confirm_password && touched.confirm_password ? (<span className='text-danger form_label'>{errors.confirm_password}</span>) : null}
                                />
                            </div>

                            <div className='d-flex justify-content-center mt-2'>
                                <SaveButton
                                    spinner={spinner}
                                    button_name={'UPDATE PASSWORD'}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </Form>
        </>
    )
}
